/*
 * ===========================================================================
 * [StrongGate Limited] [http://www.stronggate.com]
 * Copyright (c) 2022. All rights Reserved.
 * Unauthorized access, use, dissemination, distribution, reproduction of this
 * file, or a portion of, in any form is prohibited and unlawful. If you receive
 * this file, and you are not an authorized company employee, or you believe you
 * have received this file in error, please notify the sender (or originator)
 * and promptly delete this file.
 *
 * Project:
 * File: HttpRequestDelete.ts
 * Created by: Kevin
 * Create Date: 2022-12-09 18:19
 * Version Number: 1.0
 * Version Description:
 *
 * =============================================================================
 */

import {HttpRequest} from "@/commons/https/HttpRequest";
import ApiUrlBuilder from "@/commons/https/ApiUrlBuilder";
import axios from "axios";
import HttpTokenProvider from "@/commons/https/HttpTokenProvider";
import HttpRequestConfig from "@/commons/https/HttpRequestConfig";
import CheckUtil from "@/commons/utils/CheckUtil";

export default class HttpRequestDelete extends HttpRequest {

    private readonly uri: string;
    private readonly formData: FormData | null;
    private readonly searchParams: URLSearchParams | null;

    public constructor(
        apiUrlBuilder: ApiUrlBuilder,
        uri: string,
        cfg: HttpRequestConfig | null = null,
        formData: FormData | null = null,
        searchParams: URLSearchParams | null = null,
    ) {
        super(apiUrlBuilder, cfg);
        this.uri = uri;
        this.formData = formData;
        this.searchParams = searchParams;

        if (this.formData) {
            this.requestConfig.data = this.formData;
        }
    }

    public execute(token?: HttpTokenProvider | null): Promise<any> {
        HttpTokenProvider.set(this.requestConfig, token);
        const targetURL = this.getTargetURL();

        return new Promise((resolve, reject) => {
            axios.delete(targetURL, this.requestConfig)
                .then((res) => resolve(res))
                .catch((err) => reject(err));
        });
    }

    public getTargetURL(): string {
        let resolvedUri = this.apiUrlBuilder.resolve(this.uri);
        let queryString = "";

        if (this.searchParams && CheckUtil.isNotNull(this.searchParams)) {
            queryString = this.searchParams.toString();
        }

        if (queryString) {
            resolvedUri += resolvedUri.includes("?")
                ? `&${queryString}`
                : `?${queryString}`;
        }

        return resolvedUri;
    }
}